export const sortMap = {
  name: 'name',
  location: 'employee_physical_location__country',
  yearsOfExperience: 'year_start_in_profession',
  position: 'employee_position__name',
  seniority: 'employee_seniority__name',
  startDateOnBench: 'bench_start_date',
};
export const categoryIdValueForNoCategoryId = 100000;
